export enum EContactsType {
  Builder = 'builder',
  Seller = 'seller',
}

export const contactsTypeName: { [key in EContactsType]: string } = {
  [EContactsType.Builder]: 'Застройщик',
  [EContactsType.Seller]: 'Представитель застройщика',
};

export const PHONE_NUMBER_END_CROP_AMOUNT = 2;

export const PROMO_PINS_DISPLAY_LIMIT_DESKTOP = 15;
export const PROMO_PINS_DISPLAY_LIMIT_MOBILE = 5;
